import React, { useEffect } from 'react';
import { withRouter } from 'react-router';
import LocalizedStrings from 'react-localization';
import $ from 'jquery';
import CompareTableContainer from '../containers/CompareTableContainer';
import InsuranceFeatures from '../components/InsuranceFeatures';
import AutoBannerBig from '../components/banners/AutoBannerBig';


function CompareView(props) {
  useEffect(() => {
    $('#adaptive_menu').removeClass('open');
    $('#main').removeClass('ov-hidden');
    props.addToDataLayer();
    window.scrollTo(0, 0);
  }, []);

  const strings = new LocalizedStrings({
    ru: {
      main: 'Главная',
      insurance: 'Cтрахование',
      set: 'Сравнение полисов',
    },
    ua: {
      main: 'Головна',
      insurance: 'Страхування',
      set: 'Порівняння полісів',
    },
  });
  strings.setLanguage(props.locale);

  return (
    <div>
      <section id="compare_page">
        <div className="container">
          <div className="title-block text-center">
            <h2>{strings.set} КАСКО</h2>
          </div>
          <CompareTableContainer locale={props.locale} />
        </div>
      </section>
      <section id="polis-about">
        <div className="container">
          <InsuranceFeatures locale={props.locale} />
        </div>
      </section>
      <AutoBannerBig locale={props.locale} />
    </div>
  );
}

export default withRouter(CompareView);
